import { useEffect, useState, useRef } from 'react';
import axiosInstance from '../../helpers/axios';
import EditRole from './editRole';
import DeleteRole from './deleteRole';
import { Input } from 'reactstrap';
import { userActions } from '../../actions/user.actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from "@mui/material";
import { UserType } from '../../data';
import { useCurrentUser } from '../../hooks/useCurrentUser';
export default function Home() {
  const dispatch = useDispatch();
  const instituteState = useSelector((state) => state?.GETINSTITUTE?.res?.data?.data);
  const [startingPhrase, setStartingPhrase] = useState("Type Institute Name");
  const [instituteUser, setInstituteUser] = useState(null);
  const [instituteList, setInstituteList] = useState(null);
  const decode = useCurrentUser();
  const user = null;
  const [users, setUsers] = useState(null);
  const [currentInstituteId, setCurrentInstituteId] = useState(null);

  const searchInstituteRef = useRef(null);

  const fetchUsers = () => {
    if (decode?.role !== "institute_user" && decode?.role !== "institute_admin" && decode?.role !== "channel_user") {
      axiosInstance.get('/admin/users', {
        headers: {
        }
      })
      .then((res) => {
        setUsers(res?.data?.data);
      })
      .catch(error => {
        console.error('Error fetching users:', error);
      });
    } else {
      axiosInstance.get(`/admin/institute-users?instituteId=${decode?.instituteId}`)
      .then((res) => {
        setUsers(res?.data?.data);
      })
      .catch(error => {
        console.error('Error fetching institute users:', error);
      });
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [decode?.role, decode?.instituteId, user]);

  const getInstituteInfo = (text) => {
    const urlGetInstitute = `/institute/info/name?name=${text}`;

    if (text.length >= 4) {
      dispatch(userActions.getInstituteInfo(urlGetInstitute, user));
      setInstituteList(instituteState);
    } else {
      setInstituteList(null);
      setStartingPhrase("Type Institute Name");
      if (decode?.role !== "institute_user" && decode?.role !== "institute_admin"&&decode?.role !== "channel_user") {
        // Fetch users when clearing input
        axiosInstance.get('/admin/users', {
          headers: {
          }
        })
        .then((res) => {
          setUsers(res?.data?.data);
        })
        .catch(error => {
          console.error('Error fetching users:', error);
        });
      }
    }

    // Handle case where text is empty
    if (text.trim() === '') {
      setCurrentInstituteId(null);
      setInstituteUser(null);
    }
  };

  const handleSearchInstituteDetails = (data) => {
    setCurrentInstituteId(data.id);

    const url = `/admin/institute-users?instituteId=${data.id}`;

    axiosInstance.get(url)
      .then(response => {
        setInstituteUser(response.data.data);
      })
      .catch(error => {
        console.error('There was an error fetching the institute details!', error);
      });

    setInstituteList(null);
    setStartingPhrase("Type Institute Name"); // Optionally reset startingPhrase
    setUsers(null); // Reset users when clearing input
    searchInstituteRef.current.value = data.brandName;
  };

  const handleInputChange = (e) => {
    const text = e.target.value;
    getInstituteInfo(text);
  };

  const getKeyFromValue = (value, obj) => {
    const result = Object.keys(obj).find(key => obj[key] === value);
    return result || value;
  }

  return (
    <div>
      { decode?.clientId!=='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&
        <div style={{ display: "block", marginTop: '20px' }}>
          <div>
            <Input
              id="searchInstituteNameBox"
              innerRef={searchInstituteRef}
              onChange={handleInputChange}
              type="text"
              placeholder={startingPhrase}
              style={{ border: '1px solid #F0F0F0', boxShadow: '0px 0px 1px 1px #D0D0D0', width: '25em' }}
            />
          </div>
          <div style={{ marginTop: '1em' }}>
            {instituteList ? instituteList.map((item) => (
              <div onClick={() => handleSearchInstituteDetails(item)} key={item.id} className="instituteName" style={{ cursor: 'pointer', border: '1px solid grey', borderRadius: '0.5em' }}>
                <p style={{ fontWeight: '600', paddingTop: '0.5em', paddingLeft: '0.5em' }}>{item.brandName}</p>
              </div>
            )) : null}
          </div>
        </div>
      }
      <TableContainer component={Paper} sx={{mt:3,mb:3, boxShadow: 3, borderRadius: 2 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F8F8F8" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", width: "10em" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "9em" }} align="center">Phone</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "9em" }} align="center">Role</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "16em" }} align="center">Email</TableCell>
              {decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&  <TableCell sx={{ fontWeight: "bold", width: "9em" }} align="center" title="Reporting Manager">Branch</TableCell>}
              {decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&  <TableCell sx={{ fontWeight: "bold", width: "9em" }} align="center" title="Reporting Manager">RM</TableCell>}
              {(decode?.role === "admin" || decode?.role === "institute_admin") && (
                <TableCell sx={{ fontWeight: "bold" ,  width: "3.5em"}} align="right">Actions</TableCell>
              )}
            </TableRow>
          </TableHead>
          {( (currentInstituteId && instituteUser) || (users && !instituteList) ) && (
            <TableBody >
              {instituteUser?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell sx={{ width: "10em" }}>{item.name}</TableCell>
                  <TableCell sx={{ width: "9em" }} align="center">{item.mobile}</TableCell>
                  <TableCell sx={{ width: "9em" }} align="center">{item.role}</TableCell>
                  <TableCell sx={{ width: "16em" }} align="center">{item.emailId}</TableCell>

                  {(decode?.role === "admin" || decode?.role === "institute_admin") && (
                    <TableCell align="right" sx={{ display: "flex", gap: "12px",  }}>
                      <EditRole updateUser={item} onUpdated={fetchUsers} />
                      <DeleteRole deleteUser={item} onDeleted={fetchUsers} />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          )}
          {( (!instituteList && !currentInstituteId && users) || (users && !instituteList) ) && (
            <TableBody>
              {users?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell sx={{ width: "10em" }}>{item.name}</TableCell>
                  <TableCell sx={{ width: "8em" }} align="center">{item.mobile}</TableCell>
                  <TableCell sx={{ width: "8em" }} align="center">{getKeyFromValue(item.role, UserType)}</TableCell>
                  <TableCell sx={{ width: "13em" }} align="center">{item.emailId}</TableCell>
                  {decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <TableCell sx={{ width: "3em" }} align="center">{item?.branchName}</TableCell>}
                  {decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <TableCell sx={{ width: "3em" }} align="center">{item?.rmName}</TableCell>}
                  {(decode?.role === "admin" || decode?.role === "institute_admin") && (
                    <TableCell align="right" sx={{ display: "flex", gap: "12px",  }}>
                      <EditRole updateUser={item} onUpdated={fetchUsers} />
                      <DeleteRole deleteUser={item} onDeleted={fetchUsers} />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          )}

        </Table>
      </TableContainer>
    </div>
    );
  }
  
